<template>
  <v-dialog
    :value="dialog"
    :max-width="400"
    :retain-focus="false"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
    @keydown.enter="submit"
  >
    <v-card outlined>
      <v-card-title>
        {{ $t('project.delete.title') }}
        <p-btn-icon
          type="close"
          btn-class="mr-n3 ml-auto"
          tabindex="4"
          @click="closeDialog"
        ></p-btn-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form" @submit.stop.prevent>
          <v-container>
            <v-row dense align="center" justify="end">
              <v-col>
                <div v-html="$t('project.delete.textHeader', project)"></div>
                <v-text-field
                  v-model.trim="confirmTitle"
                  :rules="rules.confirmTitle"
                  class="mt-2"
                  tabindex="1"
                  validate-on-blur
                  clearable
                  autofocus
                ></v-text-field>
                <div v-if="serverConfirmError" class="red--text darken-3">
                  {{ $t('project.delete.endpointValidationError') }}
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="justify-center pb-3">
        <v-btn text tabindex="3" @click="closeDialog">{{ $t('cancel') }}</v-btn>
        <v-btn text color="primary" tabindex="2" @click="submit">{{ $t('delete') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapActions } from 'vuex'

import PBtnIcon from '@/components/PBtnIcon'

import snackbarMixin from '@/mixins/snackbar.mixin'
import dialogMixin from '@/mixins/dialog.mixin'
import validationMixin from '@/mixins/validation.mixin'


export default {
  components: {
    PBtnIcon
  },


  mixins: [
    snackbarMixin,
    dialogMixin,
    validationMixin
  ],


  props: {
    project: Object
  },


  data () {
    return {
      confirmTitle: '',
      serverConfirmError: false,
      rule: {
        matchTitle: value => value === this.project.title || this.$t('project.delete.validationError')
      }
    }
  },

  computed: {
    rulesToApply () {
      const rule = this.rule

      return {
        confirmTitle: [
          rule.required(),
          rule.matchTitle
        ]
      }
    }
  },


  methods: {
    ...mapActions('project', ['deleteProject']),

    onDialogOpen () {
      this.confirmTitle = ''
      this.serverConfirmError = false
      this.resetValidation()
    },

    async submit () {
      const valid = await this.validate(this.rulesToApply)
      if (!valid) return

      try {
        this.serverConfirmError = false
        this.showSnackbarProcessing()
        await this.deleteProject({ id: this.project.id, confirmTitle: this.confirmTitle })
        this.showSnackbarSuccess(this.$t('project.delete.projectDeleted'))
        this.closeDialog()
      } catch (error) {
        this.serverConfirmError = true
        this.$log.error(error)
      } finally {
        this.hideSnackbar()
      }
    }
  }
}
</script>
